import { DocumentListTab } from '../types';

export const DOCUMENT_LIST_TABS: DocumentListTab[] = [
  {
    data_testid: 'documents-list__tab-reuired-documents',
    name: 'Required Documents',
    value: 'required',
  },
  {
    data_testid: 'documents-list__tab-all-documents',
    name: 'All Documents',
    value: 'all',
  },
];
